export function formatPrice(price: number, fraction = 2): string {
  return price.toLocaleString("ru-RU", {
    style: "currency",
    maximumFractionDigits: fraction,
    currency: "RUB",
  });
}

export function formatPriceWithoutZeros(price: number): string {
  const isWholeAmount = price % 1 === 0;
  return formatPrice(price, isWholeAmount ? 0 : 2);
}

export function formatPriceWithoutZerosAndCurrency(price: number): string {
  const rounded = Math.round(price * 100) / 100;

  const fixed = rounded.toFixed(2);
  const [integerPart, decimalPart] = fixed.split(".");

  if (decimalPart === "00") {
    return Number(integerPart).toLocaleString("ru-RU");
  }

  const formattedInteger = Number(integerPart).toLocaleString("ru-RU");
  return `${formattedInteger},${decimalPart}`;
}

export function formatPriceToTwoDecimals(value: string | number | undefined): string {
  if (!value && value != 0) {
    return "";
  }

  const num = Number(String(value));

  if (isNaN(num)) {
    return "";
  }

  return num.toFixed(2);
}
